var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { stringToDate } from '@/utils/dates';
import { IsEmpty, ValidateIf } from 'class-validator';
import { assign } from 'lodash';
var BaseDto = /** @class */ (function () {
    function BaseDto(model) {
        if (!model) {
            this.isNew = true;
        }
        else {
            this.isNew = false;
            this.id = model.id;
            this.createdAt = stringToDate(model.created_at);
            this.updatedAt = stringToDate(model.updated_at);
        }
    }
    BaseDto.prototype.toRestModel = function () {
        return {
            id: this.id,
            created_at: this.createdAt,
            updated_at: this.updatedAt,
        };
    };
    BaseDto.prototype.toGqlModel = function (merge) {
        var _a, _b;
        return assign({
            id: this.id,
            created_at: (_a = this.createdAt) === null || _a === void 0 ? void 0 : _a.toString(),
            updated_at: (_b = this.updatedAt) === null || _b === void 0 ? void 0 : _b.toString(),
        }, merge);
    };
    __decorate([
        IsEmpty(),
        ValidateIf(function (m) { return m.isNew; }),
        __metadata("design:type", Number)
    ], BaseDto.prototype, "id", void 0);
    __decorate([
        IsEmpty(),
        ValidateIf(function (m) { return m.isNew; }),
        __metadata("design:type", Date)
    ], BaseDto.prototype, "createdAt", void 0);
    __decorate([
        IsEmpty(),
        ValidateIf(function (m) { return m.isNew; }),
        __metadata("design:type", Date)
    ], BaseDto.prototype, "updatedAt", void 0);
    return BaseDto;
}());
export { BaseDto };
